// eslint-disable-next-line no-unused-vars
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';

import viewStoreContext from '../stores/viewStore';
// import locationStoreContext from '../stores/locationStore';
// import * as CONSTS from '../utils/constants';
import goTrackerConfig from 'goTrackerConfig';

const Menu = observer(()=> {
  const { t } = useTranslation();
  const viewStore = useContext(viewStoreContext);
  // const locationStore = useContext(locationStoreContext);

  const handleClose = e => {
    e.preventDefault();
    e.stopPropagation();

    viewStore.toggleMenu();
  };

  const handleLanguageChange = e => {
    e.preventDefault();
    e.stopPropagation();

    viewStore.toggleLanguage();
    viewStore.toggleMenu();
  };

  const handleClockChange = e => {
    e.preventDefault();
    e.stopPropagation();

    viewStore.toggleClock();
    viewStore.toggleMenu();
  };

  const getActiveStatus = () => {
    if (viewStore.isMenuActive === true) {
      return 'active';
    }

    return '';
  };

  return (
    <aside className={`menu ${getActiveStatus()}`}>
      <header className="header-container">
        <div className="nav-container">
          <button className="nav menu-active" aria-label="close menu" onClick={handleClose}>
            <i className="fa fa-list-ul"/>
          </button>
          <button className="nav close" aria-label="close menu" onClick={handleClose}>
            <i className="fa fa-times"/>
          </button>
        </div>
      </header>
      <section>
        <ul>
          <li className="external-link">
            <a href={`${goTrackerConfig.links.url}/${viewStore.language}/${goTrackerConfig.links.path.serviceUpdates}`}>
              <i className="far fa-exclamation-circle padding-right"/>
              {t('menu.serviceUpdates')}
            </a>
          </li>
          <li className="external-link">
            <a href={`${goTrackerConfig.links.url}/${viewStore.language}/${goTrackerConfig.links.path.fullSchedule}`}>
              <i className="far fa-clock padding-right"/>
              {t('menu.fullSchedule')}
            </a>
          </li>
          <li>
            <a href={`${goTrackerConfig.links.url}/${viewStore.language}/${goTrackerConfig.links.path.contactUs}`}>
              {t('menu.contactUs')}
              <i className="fa fa-chevron-right"/>
            </a>
          </li>
          <li>
            <button className="btn-primary" onClick={handleLanguageChange}>{t('changeLanguage')}</button>
          </li>
          <li>
            <button className="btn-primary" onClick={handleClockChange}>
              {viewStore.isTwentyFourHour ? t('twelveHourClock') : t('twentyFourHourClock')}
            </button>
          </li>
        </ul>
      </section>
    </aside>
  );
});

export default Menu;
